package org.example.project.login

import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.JsonPrimitive
import kotlinx.serialization.json.buildJsonObject
import org.example.project.manager.LumaticaApiSettings
import org.example.project.utils.All
import org.w3c.fetch.Headers
import org.w3c.fetch.RequestInit

object ZweiFaktorService {
    private val json = Json {
        ignoreUnknownKeys = true
        encodeDefaults = false
    }

    suspend fun verifyLoginChallenge(token: String, code: String, trustedDevice: Boolean): All? {
        val response = window.fetch(
            "${LumaticaApiSettings.getBaseUrl()}/api/zweifaktor/login-pruefen",
            RequestInit(
                method = "POST",
                headers = Headers().apply { append("Content-Type", "application/json") },
                body = json.encodeToString(
                    buildJsonObject {
                        put("token", JsonPrimitive(token))
                        put("code", JsonPrimitive(code))
                        put("trustedDevice", JsonPrimitive(trustedDevice))
                    }
                )
            )
        ).await()
        if (!response.ok) return null
        val raw = response.text().await()
        if (raw.isBlank() || raw == "null") return null
        return runCatching { json.decodeFromString(All.AllNames.serializer(), raw) }.getOrNull()
    }
}
